export const IPHONE_APP_URL = "https://apps.apple.com/app/chess-hotel/id874852415";
export const ANDROID_APP_URL = "https://play.google.com/store/apps/details?id=com.foggymedia.ChessHotel";

export function getAppStoreForDevice(userAgent: string) {
  if (/android/i.test(userAgent)) return ANDROID_APP_URL;
  if (/iPhone|iPad|iPod/i.test(userAgent)) return IPHONE_APP_URL;
  return null;
}
